import React from "react";
import "./style.css";

const CtaSection = (props) => {
  return (
    <div className="tp-cta-area" dir="rtl">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="tp-cta-text">
              <h2>سوسيت… عمل كريم يغيّر المفاهيم</h2>
              <p style={{ textAlign: "justify" }}>
                عندما تختار تناول طعامك في سوسيت، فأنت لا تختار مكانًا فقط، بل
                تشارك في رؤية إنسانية تؤمن بأن الفرص حق، وأن الكرامة تُبنى
                بالعمل والاندماج. <br />
                <br />
                في قلب حديقة تشرين بدمشق، وُلد سوسيت كمشروع غير ربحي يجمع بين
                الطعام والمعنى. هنا يعمل شباب وشابات من ذوي متلازمة داون، لا
                بوصفهم حالة إنسانية، بل أفرادًا منتجين يثبتون يومًا بعد يوم أن
                القدرة الحقيقية تظهر حين تُمنح الفرصة.
                <br />
                <br /> كل وجبة في سوسيت تحمل قصة أمل، وكل ابتسامة خلفها إرادة
                تتحدى الصور النمطية. المشروع لا يسعى إلى الربح، بل إلى تغيير
                النظرة المجتمعية، وخلق مساحة عمل كريمة تُمكّن هؤلاء اليافعين من
                أن يكون لهم دور وصوت ومكان في المجتمع.
                <br />
                <br /> ولا تتوقف رسالة سوسيت عند حدوده. فجميع عائداته تُخصَّص
                لدعم معهد الإعاقة الذهنية في قدسيا، الذي يحتضن أطفالًا وشبابًا
                من ذوي الإعاقات الذهنية والحركية، ويوفّر لهم الرعاية والتعليم
                والاحتواء، في بيئة تشبه العائلة وتمنح الأمان والاستمرارية.
                <br />
                <br /> سوسيت هو ترجمة عملية لقيم جمعية جذور: إنسانية، شراكة،
                وأمل يُصنع كل يوم.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
